module.exports = __webpack_public_path__ + "img/kidsskifree_2023_960x246.jpg";